export const DoRender = (doRender, component) => {
    return doRender ? component : <></>
}